// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-name_root__6_C5Z"};